import { injectable, inject } from 'inversify';
import aspectStoreModule from '@/app/aspect/apsect-state';
import { FetchService, FetchServiceSymbol } from '@/app/fetch/service';
import { CancelToken } from '@/app/shared/utils/cancel-token';
import { replaceBasePathInContent, joinUrl, withBaseUrl } from '@/app/shared/utils/base-path'

@injectable()
export class PresenterService {

  constructor(
    @inject(FetchServiceSymbol)
    private fetchService: FetchService) {
  }
  
  public async getContent(page: string, cancelToken: CancelToken): Promise<string> {
    // TODO: put basePath to courseAspect?
    const basePath = aspectStoreModule.selectedCourseAspectInstance !== null
          ? aspectStoreModule.selectedCourseAspectInstance.basePath
          : '';

    const url = joinUrl(basePath, page)
    
    const response = await this.fetchService.query(withBaseUrl(url), cancelToken, 'text')
    if (!response.success) {
      return ''
    }
    
    const content = replaceBasePathInContent(basePath)(response.value);
    return content
  }
}

export const PresenterServiceSymbol = Symbol.for('PresenterService');
